import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectCommentDto } from '../schema';
import { DataObjectCommentSchema } from '../schema/DataObjectCommentSchema';
import { expand } from 'uri-template-lite';
import { DataObjectUrl } from './DataObjectUrl';

const getDataObjectComments = (descriptionId: number) =>
  apiClient
    .get<DataObjectCommentDto>(
      expand(DataObjectUrl.COMMENTS, { id: descriptionId }),
    )
    .then((response) => DataObjectCommentSchema.array().parse(response.data));

export const useDataObjectCommentsQuery = createApiQueryHook(
  ['dataObjectComments'],
  getDataObjectComments,
);
